import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ResultsService } from 'src/app/services/results.service';
import { printRequestDTO, statesDTO, notificationType, emailNotificationDTO, organizationDTO } from 'src/app/models/providersDTO';
import { PersistenceService, StorageType } from 'angular-persistence';
import Swal from 'sweetalert2';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-sendrequest',
  templateUrl: './sendrequest.component.html',
  styleUrls: ['./sendrequest.component.scss']
})
export class SendrequestComponent implements OnInit {
  states: statesDTO[];
  printRequestPlanString:string = localStorage.getItem('PrintRequestPlans');
  plans:any[]=this.printRequestPlanString.split(',');//["ND PPO"];
  diretoryTypesString:string = localStorage.getItem('PrintDirectoryTypes');
  diretoryTypes:any[] = this.diretoryTypesString.split(',').sort((n1:any,n2:any) => n1 - n2);
  constructor(private router: Router, private formBuilder: FormBuilder, private resultservice: ResultsService, private persistenceService: PersistenceService) { }
  sendprintrequest: FormGroup;
  submitted: boolean = false;
  public orgDetails: organizationDTO = new organizationDTO();
  plan:any;
  webSiteUrl=localStorage.getItem("WebsiteUrl");
  portallogo:any= this.webSiteUrl+"assets/content/default/images/PortalLogo.png"
  facebookicon:any = this.webSiteUrl+"assets/content/default/images/facebook.png"
  linkedinicon:any = this.webSiteUrl+"assets/content/default/images/linkedin.png"
  twittericon:any = this.webSiteUrl+"assets/content/default/images/twitter.png"
  instagramicon:any=this.webSiteUrl+"assets/content/default/images/instagram.png"
  youtubeicon:any = this.webSiteUrl+"assets/content/default/images/youtube.png"

  CurrentDate:any = new Date();
  ServerDateTime =  formatDate(this.CurrentDate, 'MM/dd/yyyy hh:mm a', 'en-US', '-0500');

  ngOnInit() {
    this.drpstate();
    //this.plans = this.persistenceService.get('currentplans', StorageType.SESSION);
    this.sendprintrequest = this.formBuilder.group({
      firstname: ['', [Validators.required, Validators.pattern(/[-_\s]{0}^[a-z0-9]+([.,-_\sa-z0-9]+)*$/i)]],
      middlename: ['', Validators.pattern(/[-_\s]{0}^[a-z0-9]+([.,-_\sa-z0-9]+)*$/i)],
      lastname: ['', [Validators.required, Validators.pattern(/[-_\s]{0}^[a-z0-9]+([.,-_\sa-z0-9]+)*$/i)]],
      phonename: ['', [Validators.required, Validators.pattern(/^((\(\d{3}\) ?)|(\d{3}-))?\d{3}-\d{4}$/)]],
      email: ['', [Validators.required, Validators.email, Validators.pattern(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)]],
      plantype: ['', Validators.required],
      directorytype: ['', Validators.required],
      //notes: ['', [Validators.required, Validators.pattern(/[-_\s]{0}^[a-z0-9]+([.,#-_\sa-z0-9]+)*$/i)]],
      diraddress1: ['', [Validators.required, Validators.pattern(/[-_\s]{0}^[a-z0-9]+([.,#-_\sa-z0-9]+)*$/i)]],
      dircity: ['',[Validators.required, Validators.pattern(/[-_\s]{0}^[a-z0-9]+([-_\sa-z0-9]+)*$/i)]],
      dirstate: ['', Validators.required],
      dirzip: ['', [Validators.required, Validators.pattern(/^\d{5}$|^\d{5}-\d{4}$|^\d{9}$/)]],
      // shpaddress1: ['', [Validators.required, Validators.pattern(/[-_\s]{0}^[a-z0-9]+([.,#-_\sa-z0-9]+)*$/i)]],
      // shpcity: ['',[Validators.required, Validators.pattern(/[-_\s]{0}^[a-z0-9]+([-_\sa-z0-9]+)*$/i)]],
      // shpstate: ['', Validators.required],
      // shpzip: ['', [Validators.required, Validators.pattern(/^\d{5}$|^\d{5}-\d{4}$|^\d{9}$/)]],
      diraddress2: ['',Validators.pattern(/[-_\s]{0}^[a-z0-9]+([.,#-_\sa-z0-9]+)*$/i)],
      //shpaddress2: ['',Validators.pattern(/[-_\s]{0}^[a-z0-9]+([.,#-_\sa-z0-9]+)*$/i)],
      //chkshipping:[false]
    });
    //this.formControl.directorytype.setValue("Provider and Pharmacy Directory");
  }

  onSubmit() {
    this.submitted = true;
    debugger;
    if (this.sendprintrequest.invalid) {
      return;
    }
    else {
      var printRequestobj = new printRequestDTO();
      //user = this.adduser.value;

      printRequestobj.firstName = this.formControl.firstname.value;
      printRequestobj.lastName = this.formControl.lastname.value;
      printRequestobj.middleName = this.formControl.middlename.value;
      printRequestobj.phoneNumber = this.formControl.phonename.value;
      printRequestobj.email = this.formControl.email.value;
      printRequestobj.directoryAddress1 = this.formControl.diraddress1.value;
      printRequestobj.directoryAddress2 = this.formControl.diraddress2.value;
      printRequestobj.directoryCity = this.formControl.dircity.value;
      printRequestobj.directoryState = this.formControl.dirstate.value;
      printRequestobj.directoryZipcode = this.formControl.dirzip.value;
      printRequestobj.shippingAddress1 = "";
      printRequestobj.shippingAddress2 = "";
      printRequestobj.shippingCity = "";
      printRequestobj.shippingState = "";
      printRequestobj.shippingZipcode = 0;
      printRequestobj.planType = this.formControl.plantype.value;
      this.plan = this.formControl.plantype.value;
      printRequestobj.directoryType = this.formControl.directorytype.value;
      printRequestobj.Notes = "";//this.formControl.notes.value;
      this.resultservice.SavePrintRequest(printRequestobj).then((result: any) => {
        if (result == 1) {
          // alert("success");  
          // this.router.navigate(['']);
          var emailNotificationAcknow = new emailNotificationDTO();
          var emailNotificationReport = new emailNotificationDTO();

          var location = "<a href='" + this.webSiteUrl + "'>website</a>";
          this.resultservice.GetNotificationsContent(notificationType.PrintRequestAcknowledgement.toString()).then((response: any) => {
            debugger;
            emailNotificationAcknow.From = response[0].fromEmail;
            emailNotificationAcknow.To=printRequestobj.email;
            // if (response[0].toEmail != undefined && response[0].toEmail != null && response[0].toEmail != '') {
            //   emailNotification.To = printRequestobj.email + "," + response[0].toEmail;
            // }
            // else {
            //   emailNotification.To = printRequestobj.email;
            // }
            if (response[0].ccEmail != undefined && response[0].ccEmail != null && response[0].ccEmail != '') {
              emailNotificationAcknow.Cc = response[0].ccEmail;
            }
            if (response[0].toEmail != undefined && response[0].toEmail != null && response[0].toEmail != '') {
              emailNotificationAcknow.Bcc = response[0].toEmail;
            } 
            emailNotificationAcknow.Subject = response[0].subjectLine;

            var bodycontent = response[0].bodyContent;
            debugger;
            this.orgDetails = this.persistenceService.get('currentorgDetails', StorageType.SESSION);
            bodycontent = bodycontent.split('[[FirstName]]').join(printRequestobj.firstName)
              .split('[[LastName]]').join(printRequestobj.lastName).split('[[SupportMessage]]').join("Support Team")
              .split('[[CHPPhone]]').join(this.orgDetails.orgPhone).split('[[CHPEmail]]').join(this.orgDetails.orgEmail)
              .split('[[CHP]]').join(this.orgDetails.orgName)
              .split('[[PortalUrl]]').join(location)
              .split('[[Plan]]').join(this.plan)
              .split('[[FacebookLink]]').join(this.orgDetails.facebookLink)
              .split('[[LinkedinLink]]').join(this.orgDetails.linkedInLink)
              .split('[[TwitterLink]]').join(this.orgDetails.twitterLink)
              .split('[[InstagramLink]]').join(this.orgDetails.instagramLink)
              .split('[[YoutubeLink]]').join(this.orgDetails.youtubeLink)
              .split('[[portallogo]]').join(this.portallogo)
              .split('[[facebookicon]]').join(this.facebookicon)
              .split('[[linkedinicon]]').join(this.linkedinicon)
              .split('[[twittericon]]').join(this.twittericon)
              .split('[[instagramicon]]').join(this.instagramicon)
              .split('[[youtubeicon]]').join(this.youtubeicon)
              .split('[[CurrentDate]]').join(this.ServerDateTime)
              emailNotificationAcknow.Content = bodycontent;
            this.resultservice.SendEmailNotification(emailNotificationAcknow).then((result: any) => {

              //this.router.navigate(['']);
            })

          })
          this.resultservice.GetNotificationsContent(notificationType.PrintRequestReporting.toString()).then((response: any) => {
            debugger;
            emailNotificationReport.From = response[0].fromEmail;
            emailNotificationReport.To = response[0].toEmail;
            if (response[0].ccEmail != undefined && response[0].ccEmail != null && response[0].ccEmail != '') {
              emailNotificationReport.Cc = response[0].ccEmail;
            }
            emailNotificationReport.Subject = response[0].subjectLine;

            var bodycontent = response[0].bodyContent;


            this.orgDetails = this.persistenceService.get('currentorgDetails', StorageType.SESSION);
            bodycontent = bodycontent.split('[[FirstName]]').join(printRequestobj.firstName)
              .split('[[MiddleName]]').join(printRequestobj.middleName).split('[[LastName]]').join(printRequestobj.lastName)
              .split('[[PhoneNumber]]').join(printRequestobj.phoneNumber).split('[[Email]]').join(printRequestobj.email)
              .split('[[PlanType]]').join(printRequestobj.planType).split('[[DirectoryType]]').join(printRequestobj.directoryType)
              .split('[[Notes]]').join(printRequestobj.Notes).split('[[DirAddress1]]').join(printRequestobj.directoryAddress1)
              .split('[[DirAddress2]]').join(printRequestobj.directoryAddress2).split('[[DirCity]]').join(printRequestobj.directoryCity)
              .split('[[DirState]]').join(printRequestobj.directoryState).split('[[DirZip]]').join(printRequestobj.directoryZipcode)
              .split('[[shipAddress1]]').join(printRequestobj.shippingAddress1).split('[[shipAddress2]]').join(printRequestobj.shippingAddress2)
              .split('[[shipCity]]').join(printRequestobj.shippingCity).split('[[shipState]]').join(printRequestobj.shippingState)
              .split('[[shipZip]]').join(printRequestobj.shippingZipcode)
              .split('[[SupportMessage]]').join("Support Team").split('[[CHPPhone]]').join(this.orgDetails.orgPhone).split('[[CHPEmail]]').join(this.orgDetails.orgEmail)
              .split('[[PortalUrl]]').join(location)
              .split('[[CHP]]').join(this.orgDetails.orgName)
              .split('[[Plan]]').join(this.plan)
              .split('[[FacebookLink]]').join(this.orgDetails.facebookLink)
              .split('[[LinkedinLink]]').join(this.orgDetails.linkedInLink)
              .split('[[TwitterLink]]').join(this.orgDetails.twitterLink)
              .split('[[InstagramLink]]').join(this.orgDetails.instagramLink)
              .split('[[YoutubeLink]]').join(this.orgDetails.youtubeLink)
              .split('[[portallogo]]').join(this.portallogo)
              .split('[[facebookicon]]').join(this.facebookicon)
              .split('[[linkedinicon]]').join(this.linkedinicon)
              .split('[[twittericon]]').join(this.twittericon)
              .split('[[instagramicon]]').join(this.instagramicon)
              .split('[[youtubeicon]]').join(this.youtubeicon)
              .split('[[CurrentDate]]').join(this.ServerDateTime)
              emailNotificationReport.Content = bodycontent;
            this.resultservice.SendEmailNotification(emailNotificationReport).then((result: any) => {

              Swal.fire({
                title: 'Thank you',
                text: 'Your request was submitted successfully!',
                icon: 'success'
              }).then((result) => {
                if (result.value) {
                  //this.contactusform.reset;
                  this.router.navigate(['']);

                }
              });
            })

          })
        }
        else {
          Swal.fire({
            text: 'SomeThink went wrong!',
            icon: 'error'
          })
        }
      });
    }
  }

  // updateAddrs(event) {
  //   debugger;
  //   if (event.target.checked) {
  //     this.sendprintrequest.controls['shpaddress1'].setValue(this.sendprintrequest.controls['diraddress1'].value);
  //     this.sendprintrequest.controls['shpaddress2'].setValue(this.sendprintrequest.controls['diraddress2'].value);
  //     this.sendprintrequest.controls['shpcity'].setValue(this.sendprintrequest.controls['dircity'].value);
  //     this.sendprintrequest.controls['shpstate'].setValue(this.sendprintrequest.controls['dirstate'].value);
  //     this.sendprintrequest.controls['shpzip'].setValue(this.sendprintrequest.controls['dirzip'].value);
  //     this.sendprintrequest.controls['shpaddress1'].disable();
  //     this.sendprintrequest.controls['shpaddress2'].disable();
  //     this.sendprintrequest.controls['shpcity'].disable();
  //     this.sendprintrequest.controls['shpstate'].disable();
  //     this.sendprintrequest.controls['shpzip'].disable();
  //   }
  //   else {
  //     this.sendprintrequest.controls['shpaddress1'].setValue('');
  //     this.sendprintrequest.controls['shpaddress2'].setValue('');
  //     this.sendprintrequest.controls['shpcity'].setValue('');
  //     this.sendprintrequest.controls['shpstate'].setValue('');
  //     this.sendprintrequest.controls['shpzip'].setValue('');
  //     this.sendprintrequest.controls['shpaddress1'].enable();
  //     this.sendprintrequest.controls['shpaddress2'].enable();
  //     this.sendprintrequest.controls['shpcity'].enable();
  //     this.sendprintrequest.controls['shpstate'].enable();
  //     this.sendprintrequest.controls['shpzip'].enable();
  //   }
  // }
  updateShipAddr(event){
    // debugger;
    // var chk=this.sendprintrequest.controls['chkshipping'].value;
    // if(chk)
    // {
    //   this.sendprintrequest.controls['shpaddress1'].setValue(this.sendprintrequest.controls['diraddress1'].value);
    //   this.sendprintrequest.controls['shpaddress2'].setValue(this.sendprintrequest.controls['diraddress2'].value);
    //   this.sendprintrequest.controls['shpcity'].setValue(this.sendprintrequest.controls['dircity'].value);
    //   this.sendprintrequest.controls['shpstate'].setValue(this.sendprintrequest.controls['dirstate'].value);
    //   this.sendprintrequest.controls['shpzip'].setValue(this.sendprintrequest.controls['dirzip'].value);
    // }
  }
  btnCancel() {
    this.router.navigate(['']);
  }
  public drpstate() {
    this.resultservice.getAllStates().subscribe((data: any[]) => {
      this.states = data;

    });
  }
  get formControl() {
    return this.sendprintrequest.controls;
  }
  onPlanSelected(value:string){
    debugger;
    console.log("the selected value is " + value);
    // if(value.toUpperCase()=="VT HMO")
    // {
    //   this.diretoryTypes=this.diretoryTypesString.split(',').sort((n1:any,n2:any) => n1 - n2);
    //   this.diretoryTypes=  this.diretoryTypes.filter(function(value, index, arr){ 
    //     return value !='Provider Diretory - Plan Year 2023';
    //   });
    // }
    // else
    // {
    //   this.diretoryTypes= this.diretoryTypesString.split(',').sort((n1:any,n2:any) => n1 - n2);
    // }
    if(value.toUpperCase().includes('MAPD'))
    {
      //debugger;
      this.diretoryTypes=this.diretoryTypesString.split(',').sort((n1:any,n2:any) => n1 - n2);
      //this.diretoryTypes.pop();
      this.diretoryTypes=this.diretoryTypes.slice(0, 1); //first item
      this.formControl.directorytype.setValue(this.diretoryTypes.slice(0, 1)); //auto select
    }
    else if(value.toUpperCase().includes('MA ONLY'))
    {
      this.diretoryTypes= this.diretoryTypesString.split(',').sort((n1:any,n2:any) => n1 - n2);
      this.diretoryTypes=this.diretoryTypes.slice(-1); //last item
      this.formControl.directorytype.setValue(this.diretoryTypes.slice(-1)); //auto select

    }
    else  if(value.toUpperCase().includes(''))
    {
      this.diretoryTypes= this.diretoryTypesString.split(',').sort((n1:any,n2:any) => n1 - n2);
      
    }
    else  
    {
      this.diretoryTypes= this.diretoryTypesString.split(',').sort((n1:any,n2:any) => n1 - n2);
      this.diretoryTypes=this.diretoryTypes.slice(0, 1);
    }
}
}

